import { rankingItems } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            暴走黑料与黑料社系列热度排行榜
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div
                className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg text-sm md:text-base font-heading font-black flex-shrink-0 ${
                  rankColors[item.rank] || 'bg-background-300 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs">{item.heat}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-1 line-clamp-1">
                  {item.desc}
                </p>
              </div>

              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-300 text-lg md:text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}